import React from 'react';
import { useModalContext } from 'contexts/modal';
import styles from './styles.module.scss';
import Image from 'next/image';
import data from './data.json';
import Button from 'components/control/button';
import { ArrowForward } from '@mui/icons-material';
import Link from 'components/link';
import { trackEvent } from 'utils/google-tag-manager';
import { useIsMobile } from 'hooks/use-size-class';
import Listing from 'data/listing';
import { GTM_CLICK_VALUATION_TIPS_ESTIMATE_BUTTON, GTM_CLICK_VALUATION_TIPS_LINK } from 'constants/events';

interface Props {
  listing?: Listing;
}

export default function ValuationTips({ listing }: Props) {
  const { blogLinks } = data;
  const isMobile = useIsMobile();
  const { openModal } = useModalContext();

  const getConsultation = () => {
    trackEvent(GTM_CLICK_VALUATION_TIPS_ESTIMATE_BUTTON);
    if (!isMobile) {
      openModal('home-appraisal-connection-request-popup', { listing: listing! });
    } else {
      openModal('home-appraisal-connection-request', { listing: listing! });
    }
  };

  return (
    <div className={styles.component}>
      <div className={styles['image-wrapper']}>
        <Image
          src={'/next/assets/images/valuation-tips.png'}
          alt='Person pointing to a house'
          layout='fill'
          style={{ objectFit:'contain' }}
        />
      </div>
      <div className={styles['links-container']}>
        <h2>{'Enhance Your Home\'s Value'}</h2>
        {blogLinks.map((item, index) => {
          return (
            <p key={index} className={styles.link}>
              <Image
                src={'/next/assets/images/sparkle.png'}
                alt='Person pointing to a house'
                width={15}
                height={25}
                className={styles.sparkle}
              />
              <Link href={item.link} target='_blank' className={styles['link-text']} onClick={() => trackEvent(GTM_CLICK_VALUATION_TIPS_LINK)}>
                {item.label}
                <ArrowForward className={styles.arrow} />
              </Link>
            </p>
          );
        })}
        <Button label="Get a Free Consultation" theme="secondary" onClick={() => getConsultation()} className={styles.button} />
      </div>
    </div>
  );
};
